import {
  AsYouType,
  type CountryCode,
  getCountryCallingCode,
  parsePhoneNumberWithError,
} from 'libphonenumber-js'

const NANP_CALLING_CODE = '1'
const NANP_NATIONAL_NUMBER = /^(\d{3})(\d{3})(\d{4})$/

// Displays phone numbers as (XXX) XXX-XXXX (design guidance); numbers outside the
// default country's calling code keep their international prefix.
export const formatPhoneNumber = (
  input: string | undefined,
  countryCode: CountryCode = 'US',
): string => {
  if (!input) return ''
  const [number, ext = ''] = input.split('x')
  let numberStr: string
  try {
    const parsed = parsePhoneNumberWithError(number, countryCode)
    const nanpMatch =
      parsed.countryCallingCode === NANP_CALLING_CODE
        ? NANP_NATIONAL_NUMBER.exec(parsed.nationalNumber)
        : null
    if (nanpMatch && getCountryCallingCode(countryCode) === NANP_CALLING_CODE) {
      numberStr = `(${nanpMatch[1]}) ${nanpMatch[2]}-${nanpMatch[3]}`
    } else if (parsed.countryCallingCode === getCountryCallingCode(countryCode)) {
      numberStr = parsed.formatNational()
    } else {
      numberStr = parsed.formatInternational()
    }
  } catch {
    numberStr = new AsYouType(countryCode).input(number)
  }
  if (ext) numberStr += ` ext. ${ext}`
  return numberStr
}
